import { usePublicConfig } from "@/lib/publicConfig";
import { sellerNet } from "@/lib/sellerNet";

const $ = (n) => `$${Number(n).toFixed(2)}`;

const NetCard = ({ method, price, quantity, ship, cfg, onConfigureShip }) => {
  const line = [{ price, quantity }];
  const base = sellerNet(line, 0, method, cfg);
  const shipNet = (ship || [0, 0]).map((s) => sellerNet(line, s, method, cfg).net - base.net);
  const card = method === "card";
  const range = shipNet[0] === shipNet[1] ? $(shipNet[0]) : `${$(shipNet[0])}–${$(shipNet[1])}`;
  return (
    <div className={`p-3 rounded-[14px] border ${card ? "border-[#262626] bg-[#0A0A0A]" : "border-emerald-500/40 bg-emerald-500/5"}`}
         data-testid={`seller-net-${card ? "card" : "transfer"}`}>
      <div className={`text-[10px] uppercase tracking-wider ${card ? "text-neutral-400" : "text-emerald-300"}`}>{card ? "Tarjeta · Payphone" : "Transferencia"}</div>
      <div className={`font-display text-2xl mt-0.5 ${card ? "text-white" : "text-emerald-400"}`} data-testid={`seller-net-${card ? "card" : "transfer"}-amount`}>{$(base.net)}</div>
      {ship ? <div className="text-[11px] text-neutral-400" data-testid={`seller-net-${card ? "card" : "transfer"}-ship`}>+ envío {range}</div>
        : onConfigureShip ? <button type="button" onClick={onConfigureShip} className="text-[11px] text-amber-300 underline" data-testid={`seller-net-${card ? "card" : "transfer"}-config-ship`}>Configura tu envío</button> : <div className="text-[11px] text-neutral-500">+ envío</div>}
      <div className="mt-1.5 text-[10px] font-mono text-neutral-500 leading-relaxed">
        {$(base.subtotal)} −{$(base.commission)} HIT ({base.pct}%){card ? ` −${$(base.payphone)} Payphone (${base.ppPct}%)` : ""}
      </div>
    </div>
  );
};

// P3 · LO QUE RECIBES — dos tarjetas, misma función sellerNet. ship=null → perfil sin tarifas.
export const SellerNetCards = ({ price, quantity, ship, onConfigureShip }) => {
  const cfg = usePublicConfig();
  if (!cfg.commission_tiers) return null;
  return (
    <div data-testid="seller-net-cards">
      <div className="text-[10px] uppercase tracking-wider text-neutral-500 mb-2">Lo que recibes</div>
      <div className="grid grid-cols-2 gap-2">
        <NetCard method="transfer" price={price} quantity={quantity} ship={ship} cfg={cfg} onConfigureShip={onConfigureShip} />
        <NetCard method="card" price={price} quantity={quantity} ship={ship} cfg={cfg} onConfigureShip={onConfigureShip} />
      </div>
      <div className="text-[11px] text-neutral-400 mt-2" data-testid="seller-net-cart-hint">En carrito con otras cartas tuyas puedes recibir un poco más.</div>
    </div>
  );
};
